import React from 'react';
import { Link, Navigate } from 'react-router';
import ViolationsPage from './components/ViolationsPage';
import { HIDE_SYSTEM_ROUTE } from '../../configs';
import ViolationsControlWorkPage from './components/ViolationsControlWorkPage';
import { Icons } from '../../components/base/BootstrapComponents/BootstrapComponents';

const routes = [
  {
    path: '/',
    component: () => <Navigate to="/violations" />,
    weight: 2,
    hideOnMenu: HIDE_SYSTEM_ROUTE,
    permission: [],
    children: [],
    loginRequired: true,
  },
  {
    path: '/violations',
    name: 'menu.violations',
    icon: 'violation',
    customIcon: true,
    loginRequired: true,
    component: ViolationsPage,
    weight: 2,
    permission: [],
    children: [
      {
        path: '/violations',
        name: 'menu.violations_admin',
        customIcon: true,
        loginRequired: true,
        component: ViolationsPage,
        afterContent: (
          <Link to="/violations" title="Экспорт реестра" className="after-button"><Icons
            customIcon
            icon="download"
            width={24}
            height={24}
          />
          </Link>
        ),
        weight: 2,
        permission: [],
        children: [],
      },
      {
        path: '/violations-control-work',
        name: 'menu.violations_control_work',
        customIcon: true,
        loginRequired: true,
        component: ViolationsControlWorkPage,
        afterContent: (
          <Link to="/violations" title="Экспорт реестра" className="after-button"><Icons
            customIcon
            icon="download"
            width={24}
            height={24}
          />
          </Link>
        ),
        weight: 2,
        permission: [],
        children: [],
      },
    ],
  },
];

export default routes;
